import { Select } from "@legacy/Select";
import { convertTimeValueToNumber, formatDuration, formatTimeLabel } from "./helpers";

/**
 * @param {number} min
 * @param {number} max
 * @param {number} step
 * @param {boolean} showDuration
 * Generate list of select's options.
 * @return {List of Object} [{ hours, minutes }]
 */
const _generateOptions = (min = 420, max = 1220, step = 30, showDuration) => {
  const data = [];
  if (min > max) {
    min = max;
  }

  for (let minuteValue = min; minuteValue <= max; minuteValue += step) {
    data.push({
      label: `${formatTimeLabel(minuteValue)} ${showDuration ? `(${formatDuration(minuteValue - min)})` : ""}`,
      value: minuteValue,
    });
  }
  return data;
};

/**
 * @param {Object} props
 * @param {Object} props.value Input Return Value Required (empty or not)
 * @param {Function} props.onChange Update value on Input change
 * @param {Number} props.min Minimum minutes (O by default)
 * @param {Number} props.max Maximum minutes (1440 by default)
 * @param {Number} props.step Step between minutess (1 by default)
 * @param {Boolean} props.showDuration show duration between min and option value
 */
export default function TimeInput(props) {
  const { value, onChange, maxHeight, min, max, step, showDuration, ...rest } = props;
  const initValue = convertTimeValueToNumber(value, step);

  const _onChange = (evt) => {
    const val = evt.target.value;
    if (typeof onChange === "function") {
      onChange(val);
    }
  };

  return (
    <Select
      aria-label={`select-${rest.label}`}
      role={"time"}
      value={initValue}
      onChange={_onChange}
      // MenuProps={{ classes: { paper: classes.menuPaper } }}
      data={_generateOptions(min, max, step, showDuration)}
      {...rest}
    />
  );
}

TimeInput.defaultProps = {
  min: 420,
  max: 1220,
  step: 30,
};
